
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import TrialForm from "./TrialForm";

interface TrialDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const TrialDialog = ({ open, onOpenChange }: TrialDialogProps) => {
  const handleSuccess = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px] bg-white text-black">
        <DialogHeader>
          <DialogTitle className="text-black text-xl font-semibold">Ingant Trial Request</DialogTitle>
        </DialogHeader>
        <TrialForm onSuccess={handleSuccess} />
      </DialogContent>
    </Dialog>
  );
};

export default TrialDialog;
